module.exports = __webpack_public_path__ + "static/media/app-store.cc9bf945.svg";